import type { FancyboxInstance, FancyboxOptions } from '@fancyapps/ui';

let inlineDialogId = 0;

export const ACCOUNT_FANCYBOX_DIALOG_OPTIONS: Partial<FancyboxOptions> = {
  fadeEffect: true,
  hideScrollbar: true,
  closeButton: false,
  dragToClose: false,
  zoomEffect: false,
  Zoomable: false,
  theme: 'light',
  mainClass: 'fancybox_account-dialog',
};

function getInlineDialogSelector(element: HTMLElement): string {
  if (!element.id) {
    inlineDialogId += 1;
    element.id = `account-fancybox-dialog-${inlineDialogId}`;
  }

  return `#${CSS.escape(element.id)}`;
}

export async function openAccountFancyboxDialog(
  element: HTMLElement,
  options?: Partial<FancyboxOptions>,
): Promise<FancyboxInstance | undefined> {
  try {
    const { Fancybox } = await import('@fancyapps/ui');

    return Fancybox.show(
      [{ src: getInlineDialogSelector(element), type: 'inline' }],
      {
        ...ACCOUNT_FANCYBOX_DIALOG_OPTIONS,
        ...options,
      },
    );
  }
  catch (error) {
    if (import.meta.env.DEV) {
      console.warn('[account] Failed to open Fancybox dialog', error);
    }

    return undefined;
  }
}

export async function closeAccountFancyboxDialog(): Promise<void> {
  const { Fancybox } = await import('@fancyapps/ui');

  Fancybox.close();
}
